import { useEffect, useState } from 'react';
import { eventBus } from '@/map/core/events';

// Scenario-driven colour grade / focus-pull — the cheap "post" layer.
// A `color-grade` step sets a tint + vignette over the whole viewport;
// it eases between states via CSS transition and clears on scenario end.
interface Grade {
  tint: string;
  intensity: number;
  vignette: number;
}

const NEUTRAL: Grade = { tint: 'transparent', intensity: 0, vignette: 0 };

export function ColorGrade() {
  const [grade, setGrade] = useState<Grade>(NEUTRAL);

  useEffect(() => {
    const unsub = eventBus.on('color-grade', (d) => {
      setGrade({
        tint: d.tint ?? 'transparent',
        intensity: d.intensity ?? 0,
        vignette: d.vignette ?? 0,
      });
    });
    const reset = eventBus.on('scenario:end', () => setGrade(NEUTRAL));
    return () => { unsub(); reset(); };
  }, []);

  return (
    <div
      className="absolute inset-0 pointer-events-none z-[15] transition-[background,box-shadow] duration-[1200ms] ease-in-out"
      style={{
        backgroundColor: grade.tint,
        opacity: grade.intensity,
        boxShadow:
          grade.vignette > 0
            ? `inset 0 0 ${200 + grade.vignette * 400}px ${grade.vignette * 240}px rgba(0,0,0,0.85)`
            : 'none',
        mixBlendMode: 'multiply',
      }}
    />
  );
}
